import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withContext as higherOrder } from '../../extenders';
function withContext(analyticsContext) {
    return higherOrder(analyticsContext)(this);
}
AnalyticsDispatcher.prototype.withContext = withContext;
//# sourceMappingURL=withContext.js.map